var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModalComPlusIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 22,
    viewBox: "0 0 27 27",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.485951,
    y: 0.485951,
    width: 26.0281,
    height: 26.0281,
    rx: 6.85486,
    stroke: "#1D4469",
    strokeWidth: 0.971903
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7012 21.265C13.1757 21.265 12.75 20.8229 12.75 20.2772V7.71434C12.75 7.16869 13.1757 6.72656 13.7012 6.72656C14.2266 6.72656 14.6524 7.16869 14.6524 7.71434V20.2772C14.6524 20.8229 14.2266 21.265 13.7012 21.265Z",
    fill: "#284356"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.75 14.9836H7.65236C7.12692 14.9836 6.70117 14.5414 6.70117 13.9958C6.70117 13.4501 7.12692 13.008 7.65236 13.008H19.75C20.2754 13.008 20.7012 13.4501 20.7012 13.9958C20.7012 14.5414 20.2754 14.9836 19.75 14.9836Z",
    fill: "#284356"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalComPlusIcon);
export default __webpack_public_path__ + "static/media/modalComPlusIcon.450c8bfc748a9e633157eab606898a14.svg";
export { ForwardRef as ReactComponent };